import { render, staticRenderFns } from "./functional-zoning-category.vue?vue&type=template&id=1dd322ec&scoped=true&lang=html&"
import script from "./functional-zoning-category.vue?vue&type=script&lang=js&"
export * from "./functional-zoning-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd322ec",
  null
  
)

export default component.exports